import React, { FC, useCallback } from 'react'
import { Layout } from 'components/Layout'
import { CompleteTemplate } from 'components/Templates'
import { useDispatch } from 'react-redux'
import { push } from 'connected-react-router'

const ContractComplete: FC = () => {
  const dispatch = useDispatch()
  const backToTop = useCallback(() => {
    dispatch(push('/'))
  }, [dispatch])

  return (
    <Layout title={'クレジットカード情報編集完了'}>
      <CompleteTemplate
        description={'登録されたカードで次回請求が行われます'}
        iconPath={'/icon/done/card.svg'}
        label={'クレジットカード情報の\n登録が完了しました'}
        backToTop={backToTop}
      />
    </Layout>
  )
}

export default ContractComplete
